/* eslint-disable standard/object-curly-even-spacing */

import { getUpdateItem, getReleaseCountry, getInciList, getInciDetail, getRelatedBasfProduct, getGroupList, getBrandList, getInciAppAnalysis, getTop10ProductContainInci, getConsumerProductChartData, getRelatedFormulation, getMoreInfoData, getInciMoreFormulation } from '@/axios/api/ingredientClient'
const UPDATE_RELEASE_COUNTRY = 'UPDATE_RELEASE_COUNTRY'
const UPDATE_TABLE_LOADING = 'UPDATE_TABLE_LOADING'
const UPDATE_LIST_DATA = 'UPDATE_LIST_DATA'
const UPDATE_TOTAL = 'UPDATE_TOTAL'
const UPDATE_REAL_TOTAL = 'UPDATE_REAL_TOTAL'
const UPDATE_SEARCH = 'UPDATE_SEARCH'
const UPDATE_INCI_DETAIL = 'UPDATE_INCI_DETAIL'
const UPDATE_RELATED_BASF_PRODUCT = 'UPDATE_RELATED_BASF_PRODUCT'
const state = {
  releaseCountry: [],
  tableLoading: false,
  inciList: [],
  pager: {
    current: 1,
    size: 10,
    total: 0,
    realTotal: 0
  },
  pageParam: {
  },
  inciDetail: {
  },
  relatedBASFProduct: []
}

const getters = {
  releaseCountry: state => state.releaseCountry.map(v => {
    return {
      ...v,
      name: v.countryName
    }
  }),
  tableLoading: state => state.tableLoading,
  inciList: state => state.inciList,
  pager: state => state.pager,
  pageParam: state => state.pageParam,
  inciDetail: state => state.inciDetail,
  relatedBASFProduct: state => state.relatedBASFProduct.map(v => v.tradeName).join(',')
}

const mutations = {
  [UPDATE_RELEASE_COUNTRY] (state, releaseCountry) {
    state.releaseCountry = releaseCountry
  },
  [UPDATE_TABLE_LOADING] (state, tableLoading) {
    state.tableLoading = tableLoading
  },
  [UPDATE_LIST_DATA] (state, inciList) {
    state.inciList = inciList
  },
  // 分页
  [UPDATE_TOTAL] (state, total) {
    state.pager = { ...state.pager, total }
  },
  [UPDATE_REAL_TOTAL] (state, realTotal) {
    state.pager = { ...state.pager, realTotal }
  },
  // 分页 查询
  [UPDATE_SEARCH] (state, { pager, pageParam }) {
    state.pager = pager
    if (pageParam) state.pageParam = pageParam
  },
  [UPDATE_INCI_DETAIL] (state, inciDetail) {
    state.inciDetail = inciDetail
  },
  [UPDATE_RELATED_BASF_PRODUCT] (state, relatedBASFProduct) {
    state.relatedBASFProduct = relatedBASFProduct
  }
}

const actions = {
  async getUpdateItemApi ({ commit }, params) {
    try {
      let { data: res } = await getUpdateItem()
      return res
    } catch (e) { }
  },
  async getReleaseCountryApi ({ commit }, payload) {
    try {
      let { data: res } = await getReleaseCountry()
      commit(UPDATE_RELEASE_COUNTRY, res || [])
    } catch (e) {}
  },
  async getInciListApi ({ state, commit }, params) {
    commit(UPDATE_TABLE_LOADING, true)
    try {
      let { data: res } = await getInciList({ 
        ...params
      })
      commit(UPDATE_LIST_DATA, res.list || [])
      commit(UPDATE_TOTAL, res.total)
      commit(UPDATE_REAL_TOTAL, res.realTotal)
    } catch (e) { }
    commit(UPDATE_TABLE_LOADING, false)
  },
  // 分页 设置page
  setPagerApi ({ commit }, pager) {
    commit(UPDATE_SEARCH, { pager })
  },
  async getInciDetailApi ({ commit }, params) {
    try {
      let { data: res } = await getInciDetail(params)
      commit(UPDATE_INCI_DETAIL, res)
    } catch (e) {}
  },
  async getRelatedBasfProductApi ({ commit }, params) {
    try {
      let { data: res } = await getRelatedBasfProduct(params)
      commit(UPDATE_RELATED_BASF_PRODUCT, res || [])
      return res || []
    } catch (e) {}
  },
  async getGroupListApi ({ state, commit }, params) {
    try {
      let { data: res } = await getGroupList(params)
      return res || []
    } catch (e) { }
  },
  async getBrandListApi ({ state, commit }, params) {
    try {
      let { data: res } = await getBrandList(params)
      return res || []
    } catch (e) { }
  },
  async getInciAppAnalysisApi ({ state, commit }, params) {
    try {
      let { data: res } = await getInciAppAnalysis(params)
      return res || []
    } catch (e) { }
  },
  async getTop10ProductContainInciApi ({ state, commit }, params) {
    try {
      let { data: res } = await getTop10ProductContainInci(params)
      return res || []
    } catch (e) { }
  },
  async getConsumerProductChartDataApi ({ state, commit }, params) {
    try {
      let { data: res } = await getConsumerProductChartData(params)
      return res || []
    } catch (e) { }
  },
  async getRelatedFormulationApi ({ state, commit }, params) {
    try {
      let { data: res } = await getRelatedFormulation(params)
      return res || []
    } catch (e) { }
  },
  async getMoreInfoDataApi ({ state, commit }, params) {
    try {
      let { data: res } = await getMoreInfoData(params)
      return res || []
    } catch (e) { }
  },
  async getInciMoreFormulationApi ({ state, commit }, params) {
    try {
      let { data: res } = await getInciMoreFormulation(params)
      return res || []
    } catch (e) { }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/ingredientClient.js